import { render, staticRenderFns } from "./Nsfw.vue?vue&type=template&id=0b932fef&scoped=true&"
import script from "./Nsfw.vue?vue&type=script&lang=js&"
export * from "./Nsfw.vue?vue&type=script&lang=js&"
import style0 from "./Nsfw.vue?vue&type=style&index=0&id=0b932fef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b932fef",
  null
  
)

export default component.exports